import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e0319b68"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "div-form-request",
  class: "wrapper-form"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Li e aceito os ")
const _hoisted_3 = { class: "wrapper-button" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "header" }
const _hoisted_7 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormTextInput = _resolveComponent("FormTextInput")!
  const _component_CheckboxInput = _resolveComponent("CheckboxInput")!
  const _component_ButtonDefault = _resolveComponent("ButtonDefault")!
  const _component_Modal = _resolveComponent("Modal")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_Transition, { name: "show-user-data" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.UserConfiguration.text.formInputsInfo, (item, index) => {
          return _withDirectives((_openBlock(), _createBlock(_component_FormTextInput, {
            key: index,
            type: item.type,
            name: item.name,
            label: item.placeholder,
            errors: 
                    !_ctx.checkErrorsReturn(_ctx.messageResponse[_ctx.capitalize(item.name)])
                        ? _ctx.messageResponse[_ctx.capitalize(item.name)]
                        : item.error
                ,
            isInvalid: 
                    !_ctx.checkErrorsReturn(_ctx.messageResponse[_ctx.capitalize(item.name)])
                        ? true
                        : _ctx.inputValidationStatus[item.name] == _ctx.EValidity.Invalid
                ,
            modelValue: _ctx.user[item.name],
            "onUpdate:modelValue": ($event: any) => ((_ctx.user[item.name]) = $event)
          }, null, 8, ["type", "name", "label", "errors", "isInvalid", "modelValue", "onUpdate:modelValue"])), [
            [_directive_maska, item.mask]
          ])
        }), 128)),
        _createVNode(_component_CheckboxInput, {
          modelValue: _ctx.user.optin,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.optin) = $event)),
          nameID: 'optin',
          errors: 
                    !_ctx.checkErrorsReturn(_ctx.messageResponse.Optin)
                        ? _ctx.messageResponse.Optin
                        : _ctx.UserConfiguration.text.optin.error
                ,
          isInvalid: 
                    !_ctx.checkErrorsReturn(_ctx.messageResponse.Optin)
                        ? true
                        : _ctx.inputValidationStatus.optin == _ctx.EValidity.Invalid
                
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createElementVNode("a", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.openModal()), ["prevent"])),
              href: "#"
            }, " termos e condições "),
            _createTextVNode(" " + _toDisplayString(_ctx.Terms.textTerm), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "errors", "isInvalid"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_ButtonDefault, {
            id: "btn-step-back",
            msg: "Voltar",
            onButtonClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.backStep()))
          }),
          _createVNode(_component_ButtonDefault, {
            id: "btn-submit-request-credit",
            msg: "Solicitar",
            onButtonClicked: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submitForm()))
          })
        ]),
        _withDirectives(_createVNode(_component_Modal, {
          onButtonXModal: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openModal()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.Terms.modal.title), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", null, _toDisplayString(_ctx.Terms.modal.headerText), 1),
                _createElementVNode("h1", null, _toDisplayString(_ctx.Terms.modal.headerTitle), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Terms.modal.list, (term, index) => {
                  return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(term.text), 1))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }, 512), [
          [_vShow, !_ctx.openedModal]
        ])
      ])
    ]),
    _: 1
  }))
}